<template>
  <v-sheet color="transparent" width="100%" height="100%" v-if="reason === '1'">
   ДОБРО ПОЖАЛОВАТЬ В ОФИС ГУСЕЙ
  </v-sheet>
  <v-sheet color="transparent" width="100%" height="100%" v-else-if="reason === '1C'">
    ОТСУТСТВУЕТ СВЯЗЬ С СЕРВЕРОМ 1С
  </v-sheet>
  <v-sheet color="transparent" width="100%" height="100%" v-else>
    НЕИЗВЕСТНАЯ ОШИБКА
  </v-sheet>
</template>

<script>
export default {
  name: 'ErrorPage',
  computed: {
    reason() {
      return this.$route.query.reason || false
    }
  }
}
</script>
